import { AdditionalServicesService } from '@additional-services/services/additional-services.service';
import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { ViewOffersService } from '@view-offers/services/view-offers.service';
import { Observable, of, throwError } from 'rxjs';
import {
  catchError,
  filter,
  map,
  switchMap,
  take,
  withLatestFrom,
} from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class OptimizelyGuard {
  constructor(
    private readonly viewOffersService: ViewOffersService,
    private readonly additionalServicesService: AdditionalServicesService,
    @Inject(DOCUMENT) private document: Document
  ) {}

  offersState$ = this.viewOffersService.offersState$;
  itemOffer = this.additionalServicesService.itemOffer$;

  canActivate(): Observable<boolean> {
    return this.checkOffer().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  checkOffer() {
    return this.offersState$.pipe(
      filter((v) => Object.keys(v).length > 0),
      take(1),
      withLatestFrom(this.itemOffer),
      map(([state, offer]) => {
        const currentCost = state.data.current_plan.monthly_cost;
        const newCost = offer.subsequentPayment;

        if (this.optActive() && currentCost > newCost) {
          this.viewOffersService.loadOptimizely(true);
          return throwError(false);
        } else {
          this.viewOffersService.loadOptimizely(false);
        }

        return of(true);
      })
    );
  }

  optActive() {
    const el = this.document?.getElementById('optly');
    return el ? Array.from(el?.classList)?.includes('DS-11') : false;
  }
}
